import { RxCross2 } from "react-icons/rx"; import { AiOutlineLogin } from "react-icons/ai";
import { Link, Outlet, useLocation } from "react-router-dom";
import { useState, useEffect } from 'react';

function Dashboard() {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [mobileTasksOpen, setMobileTasksOpen] = useState(false); // 👈 Ajout du state
    const [user, setUser] = useState(null);

    const [bannerIsClosed, setBannerIsClosed] = useState(true);
    const location = useLocation();
    // const navigate = useNavigate();

    // Menu items
    const menuItems = [
        { id: "overview", label: "Accueil", icon: "🏠", path: "overview" },
        { id: "referrals", label: "Parrainages", icon: "👥", path: "referrals" },
        { id: "tasks", label: "Tâches", icon: "🧮", path: "tasks", hasSubmenu: true },
        // { id: "earnings", label: "Gains", icon: "💰", path: "earnings" },
        { id: "withdrawals", label: "Retraits", icon: "🏦", path: "withdrawals" },
        // { id: "training", label: "Formation", icon: "📚", path: "training" },
        { id: "support", label: "Aide & Liens utiles", icon: "🎧", path: "support" },
        { id: "setting", label: "Paramètres", icon: "⚙️", path: "setting" },
    ];

    // Sous-menu pour les tâches
    const tasksSubmenu = [
        { label: "Quiz", icon: "🧠", path: "/dashboard/tasks/quiz" },
        { label: "Lucky Spinning", icon: "🎡", path: "/dashboard/tasks/wheel" },
        { label: "Vidéos Ludiques", icon: "🎬", path: "/dashboard/tasks/videos/funny" },
        { label: "Vidéos Instructives", icon: "📹", path: "/dashboard/tasks/videos/instructive" },
    ];

    useEffect(() => {
        const storedUser = localStorage.getItem("user");
        // console.log(storedUser)
        if (storedUser) {
            setUser(JSON.parse(storedUser));
        }
    }, []);

    // 👈 Fermer le menu mobile tasks quand on change de page
    useEffect(() => {
        setMobileTasksOpen(false);
    }, [location.pathname]);
    const handleLougout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        window.location.reload();
    }

    const handleCloseBanner = () => {
        setBannerIsClosed(prev => !prev)
    }

    return (
        <div className="pb-[80px] md:pb-0 min-h-screen bg-gray-50">
            {/* Header mobile */}
            <div className="md:hidden bg-white border-b px-4 py-3 flex items-center justify-between sticky top-0 z-50">
                <div className="flex items-center">
                    <img src="/logo-capitalya.jpeg" alt="capitalya" className={`w-10 rounded-sm`} />

                    <div className="ml-3">
                        <h1 className="font-bold text-lg text-gray-800">CAPITALYA</h1>
                    </div>
                </div>
                <div className="text-sm flex justify-center items-center" onClick={handleCloseBanner} >
                    {/* <div className="text-green-600 font-bold">
                        {user ? (user.gain + user.gainTaches).toLocaleString() + " F CFA" : "0 F CFA"}
                    </div> */}
                    <div className="text-white font-bold text-xs flex justify-center items-center rounded-full bg-gray-500 size-10">
                        {user?.firstname[0].toUpperCase() || "U"}
                    </div>
                </div>
            </div>

            {!bannerIsClosed &&
                (
                    <div className={`md:hidden fixed z-50 right-0 top-[68px] w-[65%] bg-white rounded-md shadow-2xl flex flex-col items-center gap-6 p-4 mr-2`}>
                        <div className="flex flex-col items-center ">
                            <RxCross2 className="text-red-500 size-5 absolute right-4  hover:bg-gray-200 hover:rounded-full" onClick={handleCloseBanner} />
                            <div className="text-white font-bold text-xs flex justify-center items-center rounded-full bg-gray-500 size-10">
                                {user?.firstname[0].toUpperCase() || "U"}
                            </div>
                            <div className="font-medium text-lg flex justify-center items-center gap-1">
                                <span>{user?.firstname}</span>
                                <span>{user?.lastname}</span>
                            </div>
                            <div className="text-xs text-gray-500 font-semibold">{user?.email}</div>
                        </div>
                        <div className="border-t-2 text-red-500 flex justify-center gap-4 items-center hover:bg-gray-200 hover:rounded-md p-2" onClick={handleLougout}>
                            <p>Se déconnecter</p>
                            <div><AiOutlineLogin /></div>
                        </div>
                    </div>)
            }

            {/* Layout principal */}
            <div className="flex">
                {/* Sidebar Desktop */}
                <div className={`hidden md:h-screen md:fixed md:flex ${sidebarOpen ? 'w-64' : 'w-16'} bg-white shadow-lg transition-all duration-300 z-40`}>
                    <div className="w-full">
                        <div className="p-4 border-b">
                            <div className="flex items-center">
                                <img src="/logo-capitalya.jpeg" alt="capitalya" className={` ${sidebarOpen ? 'size-10' : 'size-8'} rounded-full`} />

                                {sidebarOpen && (
                                    <div className="ml-3">
                                        <h1 className="font-bold text-lg text-gray-800">CAPITALYA</h1>
                                        <p className="text-xs text-gray-600">Dashboard</p>
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="p-4 border-b">
                            {sidebarOpen ? (
                                <div>
                                    {/* <p className="text-sm text-gray-600">Bienvenue,</p> */}
                                    {/* <p className="font-semibold text-gray-800">{user?.firstname || "Utilisateur"}</p> */}
                                    <div className="flex flex-col items-center ">
                                        <div className="text-white font-bold text-xs flex justify-center items-center rounded-full bg-gray-500 size-10">
                                            {user?.firstname[0].toUpperCase() || "U"}
                                        </div>
                                        <div className="font-medium text-lg flex justify-center items-center gap-1">
                                            <span>{user?.firstname}</span>
                                            <span>{user?.lastname}</span>
                                        </div>
                                        <div className="text-xs text-gray-500 font-semibold">{user?.email}</div>
                                        <div className="cursor-pointer border-t-2 text-red-500 flex justify-center gap-4 items-center hover:bg-gray-200 hover:rounded-md p-1 mt-2" onClick={handleLougout}>
                                            <p>Se déconnecter</p>
                                            <div><AiOutlineLogin /></div>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="w-8 h-8 bg-gray-300 rounded-full flex items-center justify-center text-sm font-bold">
                                    {user?.firstname?.[0]}{user?.lastname?.[0]}
                                </div>
                            )}
                        </div>

                        <nav className="mt-4">
                            {menuItems.map((item) => (
                                <div key={item.id} className="relative group">
                                    <Link
                                        to={item.hasSubmenu ? "#" : `/dashboard/${item.path}`}
                                        onClick={(e) => item.hasSubmenu && e.preventDefault()}
                                        className={`w-full flex items-center px-4 py-3 text-left hover:bg-gray-100 transition-colors ${location.pathname.includes(item.path)
                                            ? "bg-blue-50 border-r-2 border-blue-600 text-blue-600"
                                            : "text-gray-700"
                                            }`}
                                    >
                                        <span className="text-lg">{item.icon}</span>
                                        {sidebarOpen && (
                                            <span className="ml-3 flex items-center justify-between w-full">
                                                {item.label}
                                                {item.hasSubmenu && <span className="text-xs">▶</span>}
                                            </span>
                                        )}
                                    </Link>

                                    {/* Sous-menu au survol */}
                                    {item.hasSubmenu && (
                                        <div
                                            className={`absolute ${sidebarOpen ? 'left-full' : 'left-16'
                                                } top-0 bg-white shadow-lg rounded-md w-48 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 z-50 ml-1`}
                                        >
                                            {tasksSubmenu.map((submenuItem, index) => (
                                                <Link
                                                    key={index}
                                                    to={submenuItem.path}
                                                    className={`flex items-center gap-2 px-4 py-3 hover:bg-blue-50 transition-colors border-b border-gray-100 last:border-b-0 ${location.pathname === submenuItem.path
                                                        ? 'bg-blue-50 text-blue-600 font-medium'
                                                        : 'text-gray-700'
                                                        }`}
                                                >
                                                    <span className="text-lg">{submenuItem.icon}</span>
                                                    <span className="text-sm">{submenuItem.label}</span>
                                                </Link>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </nav>

                        <div className="absolute bottom-4 left-4">
                            <button
                                onClick={() => setSidebarOpen(!sidebarOpen)}
                                className="p-2 rounded-md hover:bg-gray-200 bg-gray-100 transition-colors"
                            >
                                {sidebarOpen ? (
                                    <div className='to-blue-600 text-lg flex gap-4 w-48 items-center'>
                                        ◀ <span className='text-sm'>Réduire</span>
                                    </div>
                                ) : '▶'}
                            </button>

                        </div>
                    </div>
                </div>

                {/* Main Content */}
                <div className={`flex-1 md:p-6 ${sidebarOpen ? 'md:ml-64' : 'md:ml-16'} transition-all duration-300`}>
                    <header className="hidden md:block mb-6">
                        <h1 className="text-2xl font-bold text-gray-800">
                            {menuItems.find(item => location.pathname.includes(item.path))?.label || 'Dashboard'}
                        </h1>
                    </header>

                    <main className="px-4 md:px-0 pt-4 md:pt-0">
                        <Outlet />
                    </main>
                </div>
            </div>

            {/* Bottom Navigation Mobile */}
            <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t z-50">
                {/* 👈 Sous-menu Tâches (Mobile) - Affiché au-dessus de la navigation */}
                {mobileTasksOpen && (
                    <div className="absolute bottom-full left-0 right-0 bg-white border-t shadow-lg">
                        <div className="p-2">
                            <div className="flex items-center justify-between px-3 py-2 border-b">
                                <span className="font-bold text-gray-800">🧮 Tâches</span>
                                <button
                                    onClick={() => setMobileTasksOpen(false)}
                                    className="text-gray-500 hover:text-gray-700"
                                >
                                    ✕
                                </button>
                            </div>
                            <div className="grid grid-cols-2 gap-2 p-2">
                                {tasksSubmenu.map((submenuItem, index) => (
                                    <Link
                                        key={index}
                                        to={submenuItem.path}
                                        onClick={() => setMobileTasksOpen(false)}
                                        className={`flex flex-col items-center justify-center p-3 rounded-lg border-2 transition-colors ${location.pathname === submenuItem.path
                                            ? 'border-blue-500 bg-blue-50 text-blue-600'
                                            : 'border-gray-200 hover:border-blue-300 hover:bg-gray-50'
                                            }`}
                                    >
                                        <span className="text-2xl mb-1">{submenuItem.icon}</span>
                                        <span className="text-xs font-medium text-center">{submenuItem.label}</span>
                                    </Link>
                                ))}
                            </div>
                        </div>
                    </div>
                )}

                {/* Navigation principale */}
                <div className="grid grid-cols-5 text-xs">
                    {menuItems.slice(0, 3).map((item) => {
                        // 👈 Si c'est "Tâches", on gère le clic différemment
                        if (item.hasSubmenu) {
                            return (
                                <button
                                    key={item.id}
                                    onClick={() => setMobileTasksOpen(!mobileTasksOpen)}
                                    className={`flex flex-col items-center py-2 px-1 relative ${location.pathname.includes(item.path) ? 'text-blue-600' : 'text-gray-600'
                                        }`}
                                >
                                    <span className="text-lg mb-1">{item.icon}</span>
                                    <span className="text-xs">{item.label}</span>
                                    {mobileTasksOpen && (
                                        <span className="absolute top-1 right-1 w-2 h-2 bg-blue-600 rounded-full"></span>
                                    )}
                                </button>
                            );
                        }

                        return (
                            <Link
                                key={item.id}
                                to={`/dashboard/${item.path}`}
                                className={`flex flex-col items-center py-2 px-1 ${location.pathname.includes(item.path) ? 'text-blue-600' : 'text-gray-600'
                                    }`}
                            >
                                <span className="text-lg mb-1">{item.icon}</span>
                                <span className="text-xs">{item.label}</span>
                            </Link>
                        );
                    })}

                    {/* Élément "Gains" */}
                    <Link
                        to="/dashboard/earnings"
                        className={`flex flex-col items-center py-2 px-1 ${location.pathname.includes('earnings') ? 'text-blue-600' : 'text-gray-600'
                            }`}
                    >
                        <span className="text-lg mb-1">💰</span>
                        <span className="text-xs">Gains</span>
                    </Link>

                    <button
                        onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                        className="flex flex-col items-center py-2 px-1 text-gray-600 relative"
                    >
                        <span className="text-lg mb-1">⋮</span>
                        <span className="text-xs">Plus</span>
                        {mobileMenuOpen && (
                            <span className="absolute top-1 right-1 w-2 h-2 bg-blue-600 rounded-full"></span>
                        )}
                    </button>
                </div>

                {mobileMenuOpen && (
                    <div className="absolute bottom-14 left-0 right-0 bg-white shadow-md border-t grid grid-cols-1">
                        {menuItems.slice(4).map((item) => (
                            <Link
                                key={item.id}
                                to={`/dashboard/${item.path}`}
                                onClick={() => setMobileMenuOpen(false)}
                                className={`w-full text-left px-4 py-3 hover:bg-gray-100 ${location.pathname.includes(item.path) ? 'text-blue-600' : 'text-gray-700'
                                    }`}
                            >
                                {item.icon} {item.label}
                            </Link>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export default Dashboard;